import { ManualHome } from "./ManualHome";
import { ManualPage } from "./ManualPage";
import { SectionPage } from "./SectionPage";

import type { FeatureModule } from "@/types/feature";

/**
 * The manual feature owns the reading surface: home (section directory),
 * section landings, and published pages. It contributes no tool nav items —
 * the sidebar's section tree IS its navigation.
 */
export const manualFeature: FeatureModule = {
  id: "manual",
  navItems: [],
  routes: [
    { index: true, element: <ManualHome /> },
    { path: "manual/:sectionSlug", element: <SectionPage /> },
    { path: "manual/:sectionSlug/:pageSlug", element: <ManualPage /> },
  ],
};
